// extracted by mini-css-extract-plugin
module.exports = {"main":"EmptyState_main__xHOeT","icon":"EmptyState_icon__3rBW6","title":"EmptyState_title__pmRmo","description":"EmptyState_description__Ic3Pd"};